const calculateImageSizesFromWidth = (widths) => {
  return widths.map(({ mediaQuery, width }) => {
    if (mediaQuery) {
      return `${mediaQuery} ${width}px`;
    } else {
      return `${width}px`;
    }
  }).join(", ");
};
const generateSrcSet = (src, widths) => {
  return widths.map(({ width }) => {
    try {
      const url = new URL(
        src,
        typeof window !== "undefined" ? window.location.origin : void 0
      );
      if (!url.searchParams.get("width")) {
        url.searchParams.set("width", width.toString());
      }
      return `${url.toString()} ${width}w`;
    } catch {
      return void 0;
    }
  }).filter(Boolean).join(", ");
};
export {
  calculateImageSizesFromWidth,
  generateSrcSet
};
